import { SessionExpireState } from './session-expire.state';
import { PhysicalPlatforms } from '@shared-enums';

export const authenticationInitialState: SessionExpireState = {
  platform: PhysicalPlatforms.WEB,
};
